<div id="disclosuremodal"  class="modal-content">
  <div class="modal-header">
    <div
      class="modal-title gb-headline1 mb-6"
      id="exampleModalLabel"
      [translate]="'disclosure_modal_header'"
    ></div>
    <div class="dismiss" (click)="trackingService.fireProp10Tracking('shop:update plan:disclosure modal:button:close','','','close','',true); bsModalRef.hide()" aria-label="Close">
      <a class="gb-icon-button" style="text-decoration: none" tabindex="0">
        <span aria-hidden="true" class="icon-ui-close"></span>
      </a>
    </div>
  </div>
  <div class="modal-body">
    <div *ngFor="let item of product">
      <div *ngIf="item.disclosure">
        <div
          class="modal-title gb-body1 heavy mb-4 pl-8"
          id="exampleModalLabel"
          *ngIf="item.displayName"
        >
          {{item.displayName}}
        </div>
        <p class="gb-body1 pl-8 pr-9">{{item.disclosure}}</p>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      class="col-4 float-left p-1 firstlet-cap gb-primary-button"
      aria-label="Switch plan "
      data-dismiss="modal"
      aria-label="Close"
      (click)="trackingService.fireProp10Tracking('shop:update plan:disclosure modal:button:got it','','','got it','',true); bsModalRef.hide()"
      [translate]="'modal_gotIt_btn'"
    ></button>
  </div>
</div>
